import React from "react";

import { UiMetric } from "../../../types";

function metricValueClassName(tone?: UiMetric["tone"]): string {
  const base = "eventos-value";
  if (!tone || tone === "default") return base;
  if (tone === "success") return `${base} eventos-value--profit`;
  if (tone === "danger") return `${base} eventos-value--loss`;
  if (tone === "info") return `${base} eventos-value--neutral`;
  if (tone === "warning") return `${base} eventos-value--warning`;
  return base;
}

export const MetricGrid: React.FC<{ metrics: UiMetric[]; cols?: 4 | 5 | 3 | 2 }> = ({ metrics, cols = 4 }) => {
  if (metrics.length === 0) return <div className="eventos-empty">Metrics will appear after APIs are connected.</div>;
  return (
    <div className={`eventos-grid cols-${cols}`}>
      {metrics.map((item) => (
        <div className="eventos-card eventos-metric-card" key={item.label}>
          <div className="eventos-label">{item.label}</div>
          <div className={metricValueClassName(item.tone)} title={item.value}>
            {item.value}
          </div>
          {item.delta ? <div className="eventos-subtle">{item.delta}</div> : null}
        </div>
      ))}
    </div>
  );
};
